import { createAction, props } from '@ngrx/store'
import { LpisKultura } from '../../../api/backend'

const SOURCE = '[Lpis Kulturas]'

export const setLpisKulturas = createAction(`${ SOURCE } SetLpisKulturas`, props<{ data: LpisKultura[] }>())
export const resetLpisKulturas = createAction(`${ SOURCE } ResetLpisKulturas`)
